<script setup lang="ts">
import { RouteLocationNamedRaw, RouteLocationPathRaw } from 'vue-router'

interface IProps {
  label: string
  url: string | RouteLocationPathRaw | RouteLocationNamedRaw
}

const props = defineProps<IProps>()

const router = useRouter()
const pressedButton = () => {
  router.push(props.url)
}

</script>

<template>
  <button
    class="button-container"
    @click="pressedButton"
  >
    <span class="text-xl">{{ label }}</span>
    <div>
      <FontAwesomeIcon
        icon="chevron-right"
        class="icon-cont"
      />
    </div>
  </button>
</template>

<style scoped lang="scss">
.button-container {
  @apply flex justify-start text-primary items-center font-bold outline-none hover:bg-primary/5 p-2 rounded-lg;
  .icon-cont {
    @apply w-6 ml-2 inline-flex justify-center items-center;
  }
}
</style>